// removed by extract-text-webpack-plugin
module.exports = {"list":"main_nav-2bB","list-overflow":"main_nav-2Qv"};


//////////////////
// WEBPACK FOOTER
// ../src/templates/MainNav/Menu/SecondaryMenu/secondary_menu.module.scss
// module id = 352
// module chunks = 0